import * as React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  /* 清除默认样式 */
  input {
    display: none;
    opacity: 0;
  }
  /* global */
  label {
    position: relative;
    padding: 2px;
    width: 44px;
    height: 24px;
    border-radius: 22px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &::after {
      content: '';
      position: absolute;
      left: 2px;
      top: 2px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #ffffff;
      outline: 1px solid transparent;
      transition: all 0.3s ease-in-out;
    }
  }
  &:not(.checked) {
    label {
      background: rgba(255, 255, 255, 0.3);
    }
  }
  &:not(.checked, .disabled):hover {
    label::after {
      outline: 1px solid #ffc9b1;
    }
  }
  /* base */
  &.checked {
    label {
      background: #ffc9b1;
      &::after {
        transform: translateX(100%);
      }
    }
  }
  &.disabled {
    cursor: not-allowed;
    label {
      background: rgba(0, 0, 0, 0.7);
      cursor: not-allowed;
      &::after {
        background: rgba(255, 255, 255, 0.5);
      }
    }
  }
`

export interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  className?: string
  disabled?: boolean
  checked?: boolean
  onChange?: (...args: any[]) => any
}

const Switch: React.FC<SwitchProps> = React.forwardRef((props: SwitchProps, ref: React.Ref<HTMLInputElement>) => {
  const { className, disabled = false, checked = false, onChange } = props

  const uuid = React.useId()

  const classes = classNames(className, {
    checked,
    disabled,
  })

  const handleChange: React.MouseEventHandler<HTMLInputElement> = () => {
    if (disabled) return
    onChange?.(!checked, 'switch')
  }

  return (
    <Wrapper className={classes}>
      <label htmlFor={uuid}>
        <input type="checkbox" id={uuid} ref={ref} disabled={disabled} onClick={handleChange} />
      </label>
    </Wrapper>
  )
})

export default Switch
